// Manually-entered leads — companies a collaborator adds by hand, merged into
// the lead directories alongside the imported data. Stored
// UNSCOPED (shared per browser/workspace, unlike per-user stores) so every
// collaborator sees the same directory; each row carries who added it, which
// powers the Source column + filter.
const STORAGE_KEY = 'revailosales.manualLeads'

const uid = () => `manual_${Math.random().toString(36).slice(2, 10)}`

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    // A malformed store must not crash a render: anything but the
    // expected shape is treated as empty.
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function write(rows) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(rows))
  return rows
}

export function listManualLeads(category) {
  return read().filter((r) => !category || r._category === category)
}

// Everyone who has entered at least one lead — for the Source filter.
export function manualContributors(category) {
  const seen = new Map()
  for (const r of listManualLeads(category)) {
    const key = r._addedBy || 'unknown'
    if (!seen.has(key)) seen.set(key, { email: key, name: r._addedByName || key, count: 0 })
    seen.get(key).count += 1
  }
  return [...seen.values()].sort((a, b) => b.count - a.count)
}

// `fields` uses the same column names as imported rows (name, city_state,
// trade, website, email, contact_name, contact_phone, established,
// company_size, annual_volume, service_area). Returns the stored row.
export function addManualLead(category, fields, user) {
  const rows = read()
  const row = {
    company_id: uid(),
    ...fields,
    _category: category,
    _region: 'manual',
    _source: 'manual',
    _addedBy: user?.email || '',
    _addedByName: user?.name || user?.email || 'Teammate',
    _addedAt: new Date().toISOString(),
  }
  write([row, ...rows])
  return row
}

export function removeManualLead(companyId) {
  write(read().filter((r) => r.company_id !== companyId))
}
